import _                                               from 'underscore';
import React, { FC, useEffect }                        from 'react';
import { Card, Container, Header, List, Segment, Tab } from 'semantic-ui-react';
import { useLocation, useRouteMatch }                  from 'react-router-dom';

import { CurrentUserProfileParamsReviewSection, FlexAlign, FlexJustify, RouterLocationParams, RouterLocationState, SemanticUISize, Size, SystemEvent } from '../../../../types';

import { useCurrentUser, usePrefStates, useTabIndexToRoute }            from '../../../../hooks';
import { RouterUtility }                                                from '../../../../util';
import { Flexbox, FlexItem, Page, PageTitleContainer, StyledContainer } from '../../../containers';
import { CorvalStylizedHexContainer }                                   from '../../../components/product/CorvalStylizedHexContainer';
import { Intercom } from '../../../components/util/external/Intercom';
import { PageMeta }                                                     from '../../../containers/PageMeta';
import { UserProfileCard }                                              from '../profile/UserProfileCard';
import { UserDetailsEditor }                                            from './UserDetailsEditor';
import { IntercomIdentifier } from '../../../components/util/external/IntercomIdentifier';


const UserDetailsPage: FC = ( props ) => {
	
	let match                  = useRouteMatch<RouterLocationParams.CurrentUserProfile>(),
	    { currentUser }        = useCurrentUser(),
	    [ , prefs, prefEnums ] = usePrefStates(),
	    tabKey                 = prefEnums.USER_DETAILS_SECTION;
	
	// map route sections to tab indexes
	let { getRouteAsIndex, getIndexAsRoute } = useTabIndexToRoute( {
		[ CurrentUserProfileParamsReviewSection.DETAILS ]:  0,
		[ CurrentUserProfileParamsReviewSection.PROJECTS ]: 1,
		[ CurrentUserProfileParamsReviewSection.ORGS ]:     2,
	} )
	
	useEffect( () => {
		
		let routedSection  = match.params.section,
		    currentSection = prefs.get( tabKey );
		
		if( routedSection ){
			
			currentSection = getRouteAsIndex( routedSection );
			
			// update the prefs and url is route matched.
			if( !_.isNull( currentSection ) ){
				
				handleSectionToggled( null, { activeIndex: currentSection } );
			}
		}
		
	}, [ match.params ] )
	
	let handleSectionToggled = ( e: SystemEvent, { activeIndex }: { activeIndex: number } ) => {
		
		// get next route url to update
		let nextRouteSection = getIndexAsRoute( activeIndex );
		
		if( nextRouteSection ){
			
			// save the preference
			prefs.update( prefEnums[ tabKey ], activeIndex );
			
			// silently update the url outside of the router
			window.history.replaceState( null, null, RouterUtility.getRoute( 'CURRENT_USER.DETAILS', { section: nextRouteSection } ) );
		}
	}
	
	return (
		
		<Page name={ 'user-profile' }
		      padMainHorizontal={ false }
		      padMainVertical={ false }
		      allowContentScroll={ true }>
			
			<CorvalStylizedHexContainer fill={ 'area' } size={ SemanticUISize.MINI } fadeDirection={ 'down' }/>
			
			<PageTitleContainer title={ `My Account` }/>
			
			<PageMeta title={ 'Users' }>
				
				<Container className={ 'padding-lg-vertical fadeIn' }>
					
					<Segment raised>
						<StyledContainer padding={ Size.MD }>
							
							
							<Flexbox align={ FlexAlign.START } justify={ FlexJustify.SPACE_BETWEEN }>
								
								<FlexItem noGrow>
									
									<UserProfileCard account={ currentUser } showDetails={ false }/>
								
								</FlexItem>
								
								<FlexItem basis={ 50 } className={ 'margin-lg-left' }>
									
									<Tab key={ prefs.get( tabKey ) }
									     defaultActiveIndex={ prefs.get( tabKey ) }
									     onTabChange={ handleSectionToggled }
									     menu={ {
										     secondary: true,
										     pointing:  true,
										     color:     'purple'
									     } }
									     renderActiveOnly={ true }
									     panes={ [
										     {
											
											     menuItem: 'Details',
											     render:   () => (
												     <Tab.Pane className={ 'no-border' }>
													     <PageMeta section={ 'Users' } title={ 'User Details' }>
														     <UserDetailsEditor accountId={ currentUser.id }/>
													     </PageMeta>
												     </Tab.Pane>
											
											     )
										     }, /*{
								     	
										     menuItem: 'Managed Projects',
										     render:   () => (
										     	/!* TODO: Update to a project management editor *!/
											     <Tab.Pane className={ 'no-border' }>
												     <List>
													     <FinePrintMessage>Projects you administer will be managed here.</FinePrintMessage>
													     {/!*{ organizations.map( o => (
														     <>
															     <ItemFromQuery
																     as={ Header }
																     query={ SystemAccountingQueries.queries.GET_ORGANIZATION() }
																     queryOptions={ { variables: { id: o.organizationId } } }
																     queryResultObject={ data => _.first( data.organizations ) }>
																     { ( p: CorvalOrganization ) => p.name }
															     </ItemFromQuery>
															
															     <List.Item key={ o.organizationId }>
																     <UserProjectListing accountId={ currentUser.id } organizationId={ o.organizationId }/>
															     </List.Item>
														     </>
													     ) ) }*!/}
												     </List>
											     </Tab.Pane>
										     )
									     }, {
								     	
										     menuItem: 'Managed Organizations',
										     render:   () => (
											     /!* TODO: Update to an organization management editor *!/
											     <Tab.Pane className={ 'no-border' }>
												     <FinePrintMessage>Organizations you administer will be managed here.</FinePrintMessage>
												     {/!*<ListFromQuery
													     as={ Header }
													     query={ SystemAccountingQueries.queries.GET_ORGANIZATIONS( `id name` ) }
													     queryOptions={ { variables: { where: { id_in: _.pluck( organizations, 'organizationId' ) } } } }
													     queryResultObject={ data => data.organizations }
													     itemComponent={ ( props: ListFromQueryItemProps ) => (
														     <>
															     <Header content={ props.item.name }/>
														     </>
													     ) }/>*!/}
											
											     </Tab.Pane>
										     )
									     }*/
									
									     ] }>
									
									</Tab>
								
								</FlexItem>
							
							</Flexbox>
						
						
						</StyledContainer>
					</Segment>
				</Container>
			
			</PageMeta>
			
			<IntercomIdentifier />
		
		</Page>
	);
};

export { UserDetailsPage }
